module.exports = __webpack_public_path__ + "static/media/backdrop_temp.e42ca41c.png";